import { ChangeDetectionStrategy, Component } from '@angular/core';
import { O2OOrderViewComponent } from '../../../o2o/view/o2o-order-view.component';

@Component({
  selector: 'app-marketplace-order-view',
  standalone: true,
  imports: [O2OOrderViewComponent],
  template: `
    <app-o2o-order-view
      [enableEditButton]="false"
      [titleKey]="'order.marketplace.order_detail'"
      [summarySectionTitleKey]="'order.marketplace.summary.title'"
      [backRoute]="'/third/order'"
      [orderIdParamName]="'id'"
      [showMarketplacePrices]="true"
    ></app-o2o-order-view>
  `,
  changeDetection: ChangeDetectionStrategy.Default,
})
export class MarketplaceOrderViewComponent {}
